import React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

export default function CreditUtilizationCircle({ data }) {
  const { percent, balance, limit, available } = data;

  const chartData = {
    labels: ["Used", "Available"],
    datasets: [
      {
        data: [percent, 100 - percent],
        backgroundColor: ["#f44336", "#4caf50"],
        borderWidth: 0,
      },
    ],
  };

  return (
    <Card sx={{ borderRadius: 2, border: "1px solid", borderColor: "divider", bgcolor: "background.default" }}>
      <CardContent>
        <Typography variant="subtitle2" color="text.secondary" mb={1}>
          Credit Utilization
        </Typography>
        <Box sx={{ width: "100%", maxWidth: 200, mx: "auto" }}>
          <Doughnut data={chartData} />
        </Box>
        <Box sx={{ mt: 2 }}>
          <Typography variant="body2">Total Balance: <strong>${balance.toLocaleString()}</strong></Typography>
          <Typography variant="body2">Total Limit: <strong>${limit.toLocaleString()}</strong></Typography>
          <Typography variant="body2">Available Credit: <strong>${available.toLocaleString()}</strong></Typography>
        </Box>
      </CardContent>
    </Card>
  );
}
